export default __webpack_public_path__ + "static/media/findESBNimage.843c7694.svg";